import useAuth from '@/hooks/useAuth';
import { isMobile } from '@/consts/device';
import { isPortfolioApp } from '@/utils/environment/surface';

const useFreePassEnabled = (): boolean => {
  const { isAuthorized } = useAuth();

  return isPortfolioApp() && isMobile && Boolean(isAuthorized);
};

export default useFreePassEnabled;
